
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GpsTrackerDto } from '../../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CellStore from '../../../../stores/CellStore';

@Component({
  name: 'TabGeneral',
  components: {
    vSelect,
  },
})
export default class TabGeneral extends Vue {
  readonly cellStore = new CellStore();

  @Prop({ required: true })
  tracker!: GpsTrackerDto;
  @Prop({ default: false })
  disabled!: boolean;

  get uid(): string {
    return (this as any)._uid;
  }

  async mounted(): Promise<void> {
    await this.cellStore.loadIfAbsent();
  }
}
